module.exports = __webpack_public_path__ + "img/brigadas4.efd488b6.jpg";